import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-monthly-billing-get-preview',
  templateUrl: './monthly-billing-get-preview.component.html',
  styleUrls: ['./monthly-billing-get-preview.component.css'],
})
export class MonthlyBillingGetPreviewComponent implements OnInit {
  
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = 'desc';
  logtext: string = '';
  searchText: string = '';
  columns: string[][] = [['NAME', 'Name']];
  filterQuery: string = '';
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectDataForExcel = [];
  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  date = new Date();
  scroll = { x: '900px', y: '400px' };
  FinalalizeKey: any;

  projectID = [];
  projectList = [];



  // Filter code start //
  dt = new Date();
  // month: any;
  year: number;
  START_DATE: string;
  END_DATE: string;
  radioValue = 'E';
  constructor(
    public _apiService: ApiService,
    private notificationService: NzNotificationService,
    private datePipe: DatePipe,
    public cookie: CookieService,

    private modal: NzModalService
  ) {}

  formTitle = 'Team Worklog Report';

  month: any = new Date();
  assigneeList = [];
  categoryID = 0;
  employeeData: any = [];
  maxColumns: number[] = []; //
  str = '';

  ngOnInit(): void {
    // this.yearChange(null);

    // this.loadAllAssignee();
    this.loadAllProjects(this.str);

    this.findNewAssigneeList();
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
  }
  loadAllProjects(str) {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', str).subscribe(
      (projectData) => {
        if (projectData['code'] == 200) {
          this.projectList = projectData['data'];
          for (var i = 0; i < this.projectList.length; i++) {
            this.projectID.push(this.projectList[i]['ID']);
          }
        }
      },
      (err) => {}
    );
  }
  newAssigneeList = [];
  MODULE_ASSIGNEE_ID = [];
  TYPE = '';

  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.MODULE_ASSIGNEE_ID = [];
  
    this._apiService
      .getMappedPreviewReport(this.cookie.get('userId'))
      // .getMappedPreviewReport(4)
      .subscribe(
        (data) => {
          if (data['code'] == 200) {
            this.newAssigneeList = data['data'];
  
            // Move this logic inside the success handler
            for (let i = 0; i < this.newAssigneeList.length; i++) {
              this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['USER_ID']);
            }
  
            if (this.MODULE_ASSIGNEE_ID.length !== 0) {
              this.getAllEmployeeWiseHoursDetails(true);
            }
          } else {
            this.newAssigneeList = [];
          }
        },
        (err) => {
          // Handle the error here
          console.error(err);
        }
      );
  }
  
  disabledDate = (current: Date): boolean => {
    const today = new Date();
    // Set the time to 0 to ignore time differences
    today.setHours(0, 0, 0, 0);

    // Disable months after the current month of the current year
    return (
      current &&
      (current.getFullYear() > today.getFullYear() ||
        (current.getFullYear() === today.getFullYear() &&
          current.getMonth() > today.getMonth()))
    );
  };

  startDate: any;
  endDate: any;

  yearChange(data: Date | null) {
    if (data) {
      this.startDate = new Date(data.getFullYear(), data.getMonth(), 1);
      this.endDate = new Date(data.getFullYear(), data.getMonth() + 1, 0);
    } else {
      const currentDate = new Date();
      this.startDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1
      );
      this.endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0
      );
    }

    const formattedStartDate = this.datePipe.transform(
      this.startDate,
      'yyyy-MM-dd'
    );
    const formattedEndDate = this.datePipe.transform(
      this.endDate,
      'yyyy-MM-dd'
    );

    if (formattedStartDate && formattedEndDate) {
      (this.startDate = formattedStartDate), (this.endDate = formattedEndDate);
    }

    this.getAllEmployeeWiseHoursDetails(true);
  }

  @ViewChild('table', { static: false }) table: ElementRef;

  getMonthAndYear() {
    this.month = this.dt.getMonth();
    this.year = this.dt.getFullYear();
  }

  days = new Array();

  getDaysOfMonth(MM, yyyy) {
    this.days = [];

    this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');

    this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
    this.getDaysArray(this.START_DATE, this.END_DATE);
  }

  getDaysArray(start, end) {
    for (
      var arr = [], dt = new Date(start);
      dt <= new Date(end);
      dt.setDate(dt.getDate() + 1)
    ) {
      arr.push(this.datePipe.transform(dt, 'yyyy-MM-dd'));
      this.days.push(this.datePipe.transform(dt, 'yyyy-MM-dd'));
    }
    return arr;
  }

  findTotalDays(yyyy, MM) {
    var numOfDays = new Date(yyyy, MM + 1, 0).getDate();

    var d = new Date(yyyy, MM, 1);
    this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

    var e = new Date();
    this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    for (var i = 0; i < numOfDays; i++) {
      var date = new Date(yyyy, MM, i + 1);
      if (date != null) {
        this.days[i] = this.datePipe.transform(date, 'yyyy-MM-dd');
      }
    }
  }

  onEnterGetAllEmployeeWiseHoursDetails() {
    document.getElementById('button1').focus();
    this.getAllEmployeeWiseHoursDetails(true);
  }

  changeRadioButton(radioButtonValue, apply = false) {
    if (radioButtonValue == 'A') {
      let currentDate = new Date();
      this.START_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
    } else if (radioButtonValue == 'B') {
      let currentDate = new Date();
      let previousDate = currentDate.setDate(currentDate.getDate() + -1);

      this.START_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');
    } else if (radioButtonValue == 'C') {
      let currentDate = new Date();
      let previous6thDayDate = currentDate.setDate(currentDate.getDate() + -6);
      let next7thDayDate = currentDate.setDate(currentDate.getDate() + 6);

      this.START_DATE = this.datePipe.transform(
        previous6thDayDate,
        'yyyy-MM-dd'
      );
      this.END_DATE = this.datePipe.transform(next7thDayDate, 'yyyy-MM-dd');
    } else if (radioButtonValue == 'D') {
      let currentDate = new Date();
      let lastMonth = currentDate.getMonth() + -1;
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, lastMonth + 1, 0).getDate();

      let d = new Date(currentYear, lastMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, lastMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');
    } else if (radioButtonValue == 'E') {
      let currentDate = new Date();
      let currentMonth = currentDate.getMonth();
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, currentMonth + 1, 0).getDate();

      let d = new Date(currentYear, currentMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date();
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');
    }

    if (apply) {
      this.getDaysOfMonth(this.month, this.year);
      this.applyWithRadioButtons();
    }
  }

  applyWithRadioButtons() {
    this.loadingRecords = true;
    this.pageIndex = 1;

    this._apiService
      .GETmonthlPreviewReport(
        this.START_DATE,
        this.END_DATE,
        this.projectID.toString(),

        this.MODULE_ASSIGNEE_ID.toString()
      )
      .subscribe((data) => {
        if (data['code'] == 200) {
          this.loadingRecords = false;
          this.isProjectSpinning = false;
          this.totalRecords = data['count'];
          let demodata = data['results'];

          // Format employee data and calculate totals
          let formatteddata = this.formatEmployeeData(demodata); // Use updated data
          // Add TOTAL_DAYS field to employee data
          this.employeeData = this.calculateTotalDays(formatteddata); // Calculate TOTAL_DAYS

          // Get max columns for dynamic headers
          this.maxColumns = this.getMaxColumns();
          this.initializeMaxColumns();
          const fixedColumnWidth = 260 * 2; // Reduced width for all cases
          const dynamicColumnWidth = this.maxColumns.length * 170; // Adjust multiplier if needed
          // 

          const scrollWidth = fixedColumnWidth + dynamicColumnWidth;

          this.scroll = { x: scrollWidth + 'px', y: '400px' };

          // 

          // Calculate totals for employee data
          this.calculateTotals();

          
        } else {
          this.loadingRecords = false;
          this.isProjectSpinning = false;
          this.totalRecords = 0;
          this.employeeData = [];
        }
      });
  }
  disabledEndDate = (endValue: Date): boolean => {
    if (this.START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var previousDate = new Date(this.START_DATE);
      previousDate.setDate(previousDate.getDate() + -1);

      return endValue <= new Date(previousDate);
    }
  };

  startDateHandle(open: boolean) {
    this.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.END_DATE = this.START_DATE;
    }
  }
  showFilter(): void {
    if (this.filterClass === 'filter-visible')
      this.filterClass = 'filter-invisible';
    else this.filterClass = 'filter-visible';
  }

  clearFilter() {
    this.filterQuery = '';

    this.isFilterApplied = 'default';
    this.filterClass = 'filter-invisible';

    this.dt = new Date();
    this.date = this.dt;

    this.projectID = [];
    this.TYPE = '';
    this.str = '';

    this.loadAllProjects(this.str);
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
    this.getAllEmployeeWiseHoursDetails(true);
    this.radioValue = 'E';
  }
  // Filter code End //

  getAllEmployeeWiseHoursDetails(reset: boolean = false) {
    var ok = true;
    if (this.MODULE_ASSIGNEE_ID.length == 0) {
      ok = false
    }


    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }

      this.loadingRecords = true;


      this.applyFilter();

      this._apiService
        .GETmonthlPreviewReport(
          this.START_DATE,
          this.END_DATE,
          this.projectID.toString(),
          this.MODULE_ASSIGNEE_ID.toString()
        )
        .subscribe((data) => {
          if (data['code'] == 200) {
            this.loadingRecords = false;
            this.isProjectSpinning = false;
            this.totalRecords = data['count'];
            let demodata = data['results'];

            // Format employee data and calculate totals
            let formatteddata = this.formatEmployeeData(demodata); // Use updated data
            // Add TOTAL_DAYS field to employee data
            this.employeeData = this.calculateTotalDays(formatteddata); // Calculate TOTAL_DAYS

            // Get max columns for dynamic headers
            this.maxColumns = this.getMaxColumns();
            this.initializeMaxColumns();
            const fixedColumnWidth = 260 * 2; // Reduced width for all cases
            const dynamicColumnWidth = this.maxColumns.length * 170; // Adjust multiplier if needed
            // 

            const scrollWidth = fixedColumnWidth + dynamicColumnWidth;

            this.scroll = { x: scrollWidth + 'px', y: '400px' };

            // 

            // Calculate totals for employee data
            this.calculateTotals();

            
          } else {
            this.loadingRecords = false;
            this.isProjectSpinning = false;
            this.totalRecords = 0;
            this.employeeData = [];
          }
        });
    }
  }
  calculateTotalDays(employeeData: any[]): any[] {
    return employeeData.map((employee) => {
      if (employee.TOTAL_HOURS) {
        // Split the TOTAL_HOURS into hours, minutes, and seconds
        const timeParts = employee.TOTAL_HOURS.split(':');
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);
        const seconds = parseInt(timeParts[2], 10);

        // Calculate the total hours
        const totalHours = hours + minutes / 60 + seconds / 3600;

        // Calculate the total days by dividing the total hours by 8 (standard workday)
        const totalDays = totalHours / 8;

        // Add the TOTAL_DAYS to the employee record
        return {
          ...employee,
          TOTAL_DAYS: totalDays.toFixed(2), // Rounded to 2 decimal places
        };
      }

      // If there is no TOTAL_HOURS, return the employee data as is
      return employee;
    });
  }

  formatEmployeeData(employeeData: any[]): any[] {
    return employeeData.map((employee) => {
      const formattedEmployee: any = {
        EMP_ID: employee.EMP_ID,
        EMP_NAME: employee.EMP_NAME,
        RATE_PER_HOUR: employee.RATE_PER_HOUR,
        TOTAL_HOURS: employee.TOTAL_HOURS,
        TOTAL_AMOUNT: employee.TOTAL_AMOUNT,
        P: [],
      };

      // Loop through each time/amount field
      Object.keys(employee).forEach((key) => {
        if (key.endsWith('_TIME')) {
          const timeValue = employee[key];
          const amountKey = key.replace('_TIME', '_AMOUNT');
          const amountValue = employee[amountKey];

          //

          // Extract project name from the key (before _TIME/_AMOUNT)
          const projectName = key.replace('_TIME', '');

          // Remove hyphens and underscores from projectName
          const formattedProjectName = projectName.replace(/[-_]/g, ' ');

          // Log the formatted project name for debugging
          //

          // Add project data to P array if time is non-zero and project name is valid
          if (formattedProjectName && formattedProjectName !== 'TOTAL') {
            formattedEmployee.P.push({
              PROJECT_NAME: formattedProjectName, // Project name without hyphens and underscores
              TIME: timeValue, // No conversion for TIME
              AMOUNT: amountValue, // No conversion for AMOUNT
            });
          }
        }
      });

      return formattedEmployee;
    });
  }

  // Function to get the maximum number of columns based on P array length
  initializeMaxColumns(): void {
    //

    const max = Math.max(...this.employeeData.map((e) => e.P.length));
    this.maxColumns = Array.from({ length: max }, (_, i) => i + 1);
    //
  }

  shouldShowTotalDaysColumn(): boolean {
    // Check if any employee has TOTAL_HOURS > 24
    return this.employeeData.some((employee) =>
      this.isMoreThan24Hours(employee.TOTAL_HOURS)
    );
  }

  isMoreThan24Hours(totalHours: string): boolean {
    if (!totalHours) return false;

    const [hours, minutes, seconds] = totalHours.split(':').map(Number);
    const totalInHours = hours + minutes / 60 + seconds / 3600;

    return totalInHours > 24;
  }

  // Function to calculate totals for TIME and AMOUNT for each employee and the P columns
  calculateTotals(): void {
    const totals = {
      EMP_NAME: 'Total',
      DATE: '',
      RATE_PER_HOUR: this.employeeData.reduce(
        (sum, item) => sum + item.RATE_PER_HOUR,
        0
      ),
      TOTAL_AMOUNT: this.employeeData.reduce(
        (sum, item) => sum + item.TOTAL_AMOUNT,
        0
      ),
      TOTAL_HOURS: this.calculateTotalTime(
        this.employeeData.map((item) => item.TOTAL_HOURS)
      ),
      TOTAL_DAYS: this.employeeData
        .reduce((sum, item) => sum + parseFloat(item.TOTAL_DAYS || '0'), 0)
        .toFixed(2), // Sum of TOTAL_DAYS
      P: [],
    };

    // Calculate totals for each P column (TIME and AMOUNT)
    for (let i = 0; i < this.maxColumns.length; i++) {
      const totalTime = this.calculateTotalTime(
        this.employeeData.map((item) => item.P[i]?.TIME || '00:00:00')
      );
      const totalAmount = this.employeeData.reduce(
        (sum, item) => sum + (item.P[i]?.AMOUNT || 0),
        0
      );
      totals.P.push({ TIME: totalTime, AMOUNT: totalAmount.toFixed(2) });
    }

    

    // Append totals row to the data
    this.employeeData.push(totals);
  }

  // Helper method to calculate the total time
  calculateTotalTime(timeStrings: string[]): string {
    let totalSeconds = 0;

    timeStrings.forEach((time) => {
      const [hours, minutes, seconds] = time.split(':').map(Number);
      totalSeconds += hours * 3600 + minutes * 60 + seconds;
    });

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  private getMaxColumns(): number[] {
    // Ensure P array exists for all employees before checking length
    this.employeeData.forEach((employee) => {
      if (!employee.P) {
        employee.P = [];
      }
    });

    // Calculate max length of P arrays
    const maxLength = Math.max(
      ...this.employeeData.map((employee) => employee.P.length)
    );

    return Array.from({ length: maxLength }, (_, i) => i + 1);
  }

  extractProjectNames() {
    // Extract unique project names from employee data
    this.employeeData = [
      ...new Set(
        this.employeeData.flatMap((employee) =>
          employee.PROJECTS.map((project) => project.PROJECT_NAME)
        )
      ),
    ];
  }

  fireEvent() {
    // Check if employeeData is empty
    if (this.employeeData.length <= 1) {
      this.notificationService.info('Data not found', '');
      return; // Exit the function early
    }
    this.loadprojectexcel = true;

    // Collect all unique project names
    const allProjects: any = Array.from(
      new Set(
        this.employeeData.flatMap((employee) =>
          employee.P.map((project) => project.PROJECT_NAME)
        )
      )
    );

    // Prepare header rows
    const headerRow1 = [
      'Employee Name',
      'Rate Per Hour',
      'Total Amount',
      'Total Time',
      'Total Days', // Add Total Days field
      ...allProjects.flatMap((project) => [project, '']), // Project names (we'll merge these cells)
    ];

    const headerRow2 = [
      '',
      '',
      '',
      '',
      '', // Placeholder for TOTAL DAYS subheader
      ...allProjects.flatMap((project, index) => {
        // Only add 'TIME' and 'AMOUNT' for each project, skip for the last project
        if (index === allProjects.length - 1) {
          return []; // No subheader for the last project
        }
        return ['TIME', 'AMOUNT']; // Subheaders for project time and amount
      }),
    ];

    // Prepare data rows and calculate totals
    let totalTime = 0;
    let totalAmount = 0;
    let totalRate = 0;
    let totalDays = 0;
    let projectTimes: any = new Array(allProjects.length).fill(0); // Initialize project time totals
    let projectAmounts = new Array(allProjects.length).fill(0); // Initialize project amount totals

    const employeeRows = this.employeeData.map((employee) => {
      if (employee.EMP_NAME == 'Total') {
        return null; // Return null to skip this row
      }

      const row = [
        employee.EMP_NAME,
        parseFloat(employee.RATE_PER_HOUR).toFixed(2),
        parseFloat(employee.TOTAL_AMOUNT).toFixed(2),
        employee.TOTAL_HOURS,
        employee.TOTAL_DAYS, // Use TOTAL_DAYS key directly
        ...allProjects.flatMap((projectName) => {
          const project = employee.P.find(
            (p) => p.PROJECT_NAME === projectName
          );
          if (project) {
            // Keep the time in hh:mm:ss format without converting to decimal
            const time = project.TIME; // No conversion to decimal
            projectTimes[allProjects.indexOf(projectName)] +=
              this.convertTimeToSeconds(time); // Accumulate project time in seconds

            // Accumulate project amount as a number
            const amount = parseFloat(project.AMOUNT) || 0; // Ensure it's treated as a number
            projectAmounts[allProjects.indexOf(projectName)] += amount;

            // Return the time and the amount formatted to 2 decimal places for display
            return [time, amount.toFixed(2)];
          }

          return ['', '']; // Fill gaps for missing projects
        }),
      ];

      // Calculate totals
      totalTime += this.convertTimeToSeconds(employee.TOTAL_HOURS) || 0; // Accumulate total time in seconds
      totalAmount += employee.TOTAL_AMOUNT || 0; // Accumulate total amount
      totalRate += employee.RATE_PER_HOUR || 0; // Accumulate total rate
      totalDays += parseFloat(employee.TOTAL_DAYS) || 0; // Accumulate total days (ensure numeric)

      return row;
    });

    // Debugging logs for totalDays

    // Add the "Total" row with aggregated data
    const totalRow = [
      'Total', // EMP_NAME for the total row
      totalRate, // Total rate
      totalAmount, // Total amount
      this.convertSecondsToTime(totalTime), // Convert total time from seconds to hh:mm:ss
      totalDays.toFixed(2), // Ensure TOTAL_DAYS for the Total row is formatted correctly
      // ...projectTimes.flatMap((time, index) => {
      //   const amount = projectAmounts[index];
      //   return [this.convertSecondsToTime(time), amount]; // Show total project time and amount in hh:mm:ss format
      // }),
      ...projectTimes.flatMap((time, index) => {
        // Skip the last project
        if (index === projectTimes.length - 1) {
          return []; // Do not include the last project in the total row
        }
        const amount = projectAmounts[index];
        return [this.convertSecondsToTime(time), amount]; // Show total project time and amount in hh:mm:ss format
      }),
    ];

    // Combine headers and data into one array for Excel export
    const worksheetData = [headerRow1, headerRow2, ...employeeRows, totalRow];

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Merge cells for project names (rows 0 to 1)
    const merges = allProjects.map((_, index) => ({
      s: { r: 0, c: 5 + index * 2 }, // Start after the "Total Days" column (index 5)
      e: { r: 0, c: 6 + index * 2 }, // End after the start cell (index + 1)
    }));

    ws['!merges'] = merges;

    // Define column widths
    ws['!cols'] = [
      { wch: 15 }, // DATE
      { wch: 10 }, // RATE
      { wch: 15 }, // TOTAL AMOUNT
      { wch: 15 }, // TOTAL SECONDS
      { wch: 15 }, // TOTAL DAYS
      ...allProjects.flatMap(() => [{ wch: 20 }, { wch: 10 }]), // Project columns
    ];

    // Define the header cell style
    const headerCellStyle = {
      font: {
        bold: true, // Make text bold
        color: {
          rgb: 'FFFFFF', // Set the font color to white
        },
      },
      fill: {
        fgColor: {
          rgb: '4F81BD', // Set the background color to blue (4F81BD)
        },
      },
      alignment: {
        horizontal: 'center', // Center align text horizontally
        vertical: 'center', // Center align text vertically
      },
    };

    // Apply styles to header rows
    for (let i = 0; i < headerRow1.length; i++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
      if (!ws[cellAddress]) {
        ws[cellAddress] = { t: 's', v: headerRow1[i] }; // Create the cell if it doesn't exist
      }
      ws[cellAddress].s = headerCellStyle; // Apply style to header cell
    }

    for (let i = 0; i < headerRow2.length; i++) {
      const cellAddress = XLSX.utils.encode_cell({ r: 1, c: i });
      if (!ws[cellAddress]) {
        ws[cellAddress] = { t: 's', v: headerRow2[i] }; // Create the cell if it doesn't exist
      }
      ws[cellAddress].s = headerCellStyle; // Apply style to header cell
    }

    // Create a workbook and append the worksheet
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Employee Data');

    // Save to file
    XLSX.writeFile(wb, 'Team Worklog Report.xlsx');
    this.loadprojectexcel = false;
  }

  // Helper function to convert time (hh:mm:ss) to total seconds
  convertTimeToSeconds(time) {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  // Helper function to convert total seconds back to hh:mm:ss format
  convertSecondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${this.padWithZero(hours)}:${this.padWithZero(
      minutes
    )}:${this.padWithZero(remainingSeconds)}`;
  }

  // Helper function to pad single-digit hours, minutes, and seconds with a leading zero
  padWithZero(value) {
    return value < 10 ? '0' + value : value;
  }

  filterClass: string = 'filter-invisible';
  isFilterApplied: string = 'default';

  applyFilter() {
    // this.getMonthAndYear();
    // this.getDaysOfMonth(this.month, this.year);

    this.isFilterApplied = 'primary';
    this.filterClass = 'filter-invisible';
  }

  loadprojectexcel: boolean = false;
}
